export const Modal = Object.freeze({
  Backups: "backups",
  CreateProject: "create-project",
  LineFinder: "line-finder",
  ItemFinder: "item-finder",
  TranslationKeys: "translation-keys",
  ScriptImporter: "script-importer"
})
